export { getQrTypeTranslation, QR_TYPE_TO_TRANSLATION_KEY } from './qrTypeData'
